{
  "CSAT": {
    "TITLE": "Rate your conversation",
    "PLACEHOLDER": "Tell us more...",
    "RATINGS": {
      "POOR": "😞 Poor",
      "FAIR": "😑 Fair",
      "AVERAGE": "😐 Average",
      "GOOD": "😀 Good",
      "EXCELLENT": "😍 Excellent"
    }
  }
}
